import {PlayerHost} from "./host.model";
import {PlayerMix} from "./player-mix.model";
import {PlayerShow} from "./show.model";
import {PlayerProgramBase} from "./program-base.model";
import { Expose, Type } from 'class-transformer';

export class PlayerProgram extends PlayerProgramBase  {
  @Expose({name: '_host'})
  @Type(() => PlayerHost)
  _host: PlayerHost | undefined = undefined;
  @Expose({name: '_mixes'})
  @Type(() => PlayerMix)
  _mixes: PlayerMix [] = [];
  @Expose({name: '_last_show_mix'})
  @Type(() => PlayerMix)
  _lastShowMix: PlayerMix | undefined = undefined;
  @Expose({name: '_default_mix'})
  @Type(() => PlayerMix)
  _defaultMix: PlayerMix | undefined = undefined;
  @Expose({name: '_shows'})
  @Type(() => PlayerShow)
  _shows: PlayerShow [] = [];
  @Expose({name: '_show_count'})
  _showCount = 0;
  @Expose({name: '_mix_count'})
  _mixCount = 0;

}
